import * as React from "react";
import { Check, Minus } from "lucide-react";
import { cn } from "../../lib/utils";

const Checkbox = React.forwardRef(
  (
    {
      className,
      checked = false,
      indeterminate = false,
      disabled = false,
      onChange,
      onClick,
      title,
      style,
      size = 17,
      ...props
    },
    ref
  ) => {
    const isChecked = Boolean(checked);
    const isIndeterminate = Boolean(indeterminate);

    return (
      <label
        title={title}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          cursor: disabled ? "not-allowed" : "pointer",
          userSelect: "none",
          verticalAlign: "middle",
          opacity: disabled ? 0.35 : 1,
          lineHeight: 1,
        }}
      >
        <input
          type="checkbox"
          ref={ref}
          checked={isChecked}
          disabled={disabled}
          onChange={onChange}
          onClick={onClick}
          style={{
            position: "absolute",
            opacity: 0,
            width: 0,
            height: 0,
            margin: 0,
            pointerEvents: "none",
          }}
          {...props}
        />
        <div
          className={cn("tw-transition-all tw-duration-150 tw-ease-out", className)}
          style={{
            width: size,
            height: size,
            borderRadius: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: isChecked || isIndeterminate
              ? "1.5px solid #00ADB5"
              : "1.5px solid rgba(255, 255, 255, 0.22)",
            background: isChecked || isIndeterminate
              ? "linear-gradient(135deg, #00ADB5 0%, #00888F 100%)"
              : "rgba(255, 255, 255, 0.04)",
            boxShadow: isChecked || isIndeterminate
              ? "0 2px 8px -1px rgba(0, 173, 181, 0.5)"
              : "none",
            transform: isChecked ? "scale(1)" : "scale(0.96)",
            cursor: disabled ? "not-allowed" : "pointer",
            boxSizing: "border-box",
            ...style,
          }}
          onMouseEnter={(e) => {
            if (!disabled && !isChecked && !isIndeterminate) {
              e.currentTarget.style.borderColor = "rgba(0, 173, 181, 0.65)";
              e.currentTarget.style.background = "rgba(0, 173, 181, 0.08)";
              e.currentTarget.style.boxShadow = "0 0 0 3px rgba(0, 173, 181, 0.12)";
              e.currentTarget.style.transform = "scale(1.02)";
            }
          }}
          onMouseLeave={(e) => {
            if (!disabled && !isChecked && !isIndeterminate) {
              e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.22)";
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "scale(0.96)";
            }
          }}
        >
          {isChecked && !isIndeterminate && (
            <Check
              size={size - 5}
              color="#0d1117"
              strokeWidth={3.2}
              style={{
                display: "block",
              }}
            />
          )}
          {isIndeterminate && (
            <Minus
              size={size - 5}
              color="#0d1117"
              strokeWidth={3.2}
              style={{ display: "block" }}
            />
          )}
        </div>
      </label>
    );
  }
);

Checkbox.displayName = "Checkbox";

export { Checkbox };
export default Checkbox;
